import React from 'react'
import { UIButton, type UIButtonProps } from './ui-button'

export interface UIButtonGhostProps extends
  Omit<UIButtonProps, 'variant'> {
}

/**
 * Ghost Button Component
 * Based on official shadcn button-08 block with ghost variant
 * Use for subtle actions like close, dismiss, optional secondary actions
 */
export const UIButtonGhost = React.forwardRef<HTMLButtonElement, UIButtonGhostProps>(
  (props, ref) => {
    return (
      <UIButton
        variant="ghost"
        ref={ref}
        {...props}
      />
    )
  }
)

UIButtonGhost.displayName = "UIButtonGhost"